
import CryptoJS from 'crypto-js';
import store from '../store/index';
import Utils from '../assets/js/common';
/**判断是否登录并跳转登录页 */
export function isToLogin() {
    let token = Utils.getCookie('token');
    if (token) {
        return true;
    }
    store.commit('changeGoLogin', 'login');
    return false;
}
/**时间戳转时间 */
export function getDateTime(time, format = 'YY-MM-DD hh:mm:ss') {
    if (!time) return;
    var obj = {
        'YY': new Date(time).getFullYear(),
        'MM': new Date(time).getMonth() + 1 < 10 ? '0' + (new Date(time).getMonth() + 1) : new Date(time).getMonth() + 1,
        'DD': new Date(time).getDate() < 10 ? '0' + new Date(time).getDate() : new Date(time).getDate(),
        'hh': new Date(time).getHours() < 10 ? '0' + new Date(time).getHours() : new Date(time).getHours(),
        'mm': new Date(time).getMinutes() < 10 ? '0' + new Date(time).getMinutes() : new Date(time).getMinutes(),
        'ss': new Date(time).getSeconds() < 10 ? '0' + new Date(time).getSeconds() : new Date(time).getSeconds()
    };
    for (let key in obj) {
        format = format.replace(key, obj[key])
    }
    return format;
}
/**生成uuid */
export function generateSixDigitUUID() {
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    return uuid
}
/**阿拉伯数字转中文 */
export function numberToChinese(number) {
    if (typeof number != 'number') return;
    var unitArray = ['十', '百', '千', '万', '十万', '百万', '千万', '亿'];
    var nArray = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    if (number < 10) {
        return nArray[number];
    }
    var string = number.toString();
    var length = string.length;
    var i = 1;
    for (var k = 1; k < length; k++) {
        i = i * 10;
    }
    var unit = parseInt(number / i);
    var remainder = number % i;
    var str = remainder.toString().length + 1 < length ? '零' : '';
    if (remainder >= 10) {
        return nArray[unit] + unitArray[length - 2] + str + numberToChinese(remainder);
    } else if (remainder >= 1 && remainder <= 9) {
        return nArray[unit] + unitArray[length - 2] + str + nArray[remainder];
    } else {
        return nArray[unit] + unitArray[length - 2];
    }
}
/**数字三位逗号隔开 */
export function numberDivide(number) {
    if (typeof number != 'number') return;
    number = number.toString();
    return number.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
/**首页滚动加载 */
export function scrollLoading(id, callback) {
    var div0 = document.querySelector(id);
    function loading() {
        var clientRect = div0.getBoundingClientRect();
        var viewHeight = window.innerHeight;
        if (clientRect.top < viewHeight) {
            typeof callback == 'function' && callback();
            window.removeEventListener('scroll', loading);
        }
    }
    window.addEventListener('scroll', loading);
}
/**列表触底加载 */
export function touchBottomLoading(id, callback) {
    var div = typeof id == 'string' ? document.querySelector(id) : id;
    div.onscroll = function () {
        var scrollTop = div.scrollTop;
        // 获取视口的高度
        var windowHeight = div.clientHeight;
        // 获取文档的总高度
        var documentHeight = div.scrollHeight;
        console.log(documentHeight, scrollTop, windowHeight)
        // 判断是否滚动到底部
        var isBottom = scrollTop + windowHeight >= documentHeight - 10; // 减去10是为了避免精确计算时的误差
        if (isBottom) {
            // 加载数据的操作
            console.log('到达底部，加载更多数据...');
            // 这里执行加载数据的函数或逻辑
            typeof callback == 'function' && callback();
        }
    }
}

/** JS 深度克隆
 * @param value 需要克隆的值
 */
export function deepClone(value) {
    // 排除原始类型的情况，函数时也满足此条件
    if (typeof value !== "object" || value === null) {
        return value;
    }
    // 克隆结果：1.数组 2.普通对象
    const result = Array.isArray(value) ? [] : {};
    // 设置克隆结果的原型链为 value 的原型链(即保持原型一致)
    Object.setPrototypeOf(result, Object.getPrototypeOf(value));
    // 浅层克隆
    for (const key in value) {
        // 排除原型上的属性
        if (value.hasOwnProperty(key)) {
            result[key] = deepClone(value[key]); // 针对这个对象的每一个属性值进行克隆，则达到深度克隆效果
        }
    }
    return result;
}
/**移除监听 */
export function removeTouchBottom(div) {
    div && (div.onscroll = null);
}
/**课程分类 */
export const Category = [
    {
        label: '城市更新',
        value: 'CPS'
    },
    {
        label: '智能建造',
        value: 'CIS'
    },
    {
        label: '装配式建筑',
        value: 'CPC'
    },
    {
        label: '现浇混凝土建筑',
        value: 'CIC'
    },
    {
        label: '市政工程',
        value: 'OTHER'
    },
]
/**操作类型 */
export const OPERATIONTYPE = [
    'like',
    'collect',
    'view',
    'study',
    'study_count'
]
/**首页导航 */
export const NAVLIST = [
    {
        label: '首页',
        value: 'sysHome',
        show: true,
        menu: 0,
        path: '/',
    },
    {
        label: '虚拟仿真',
        value: 'virtualSimulation',
        show: true,
        menu: 1,
        path: '/virtualSimulation',
    },
    {
        label: '虚仿课程',
        value: 'course',
        show: true,
        menu: 2,
        path: '/course',
    },
    {
        label: '院校中心',
        value: 'collegeCenter',
        show: true,
        menu: 4,
        path: '/collegeCenter',
    },
    {
        label: '数据中心',
        value: 'dataCenter',
        show: true,
        menu: 5,
        path: '/dataCenter',
    },
    {
        label: '资源库',
        value: 'resourceLibrary',
        show: true,
        menu: 6,
        path: '/resourceLibrary',
    },
    {
        label: '开放API',
        value: 'dockingPlan',
        show: true,
        menu: 7,
        path: '/dockingPlan',
    },
]
/**过滤资源课程默认图片 */
export function filterResDefault(type) {
    var obj = {
        '动画': require('../assets/image/resource/cartoon.png'),
        '文档': require('../assets/image/resource/document.png'),
        '试卷': require('../assets/image/resource/paper.png'),
        '模型': require('../assets/image/resource/model.png'),
        '图片': require('../assets/image/resource/picture.png'),
        'ppt': require('../assets/image/resource/ppt.png'),
        '题库': require('../assets/image/resource/subject.jpg'),
        '视频': require('../assets/image/resource/video.png'),
        '虚拟仿真': require('../assets/image/resource/virtual.png'),
        '仿真软件': require('../assets/image/resource/virtual.png'),
        'CIC': require('../assets/image/course/CIC.png'),
        'CIS': require('../assets/image/course/CIS.png'),
        'CPC': require('../assets/image/course/CPC.png'),
        'CPS': require('../assets/image/course/CPS.png'),
        'OTHER': require('../assets/image/course/OTHER.png'),
    }
    return obj[type] || '';
}
/**将秒转成小时 */
export function secondToHours(second) {
    if (second < 0) return;
    var h = 0;
    var m = 0;
    var s = 0;
    h = Math.floor(second / 3600);
    var r1 = second % 3600;
    if (r1 > 0) {
        m = Math.floor(r1 / 60);
        s = r1 % 60;
    }
    h = h < 10 ? '0' + h + ':' : h + ':';
    m = m < 10 ? '0' + m + ':' : m + ':';
    s = s < 10 ? '0' + s : s;
    return h + m + s;
}
// 跳转仿真加密
export function EncryptU3d(o) {
    let key = CryptoJS.enc.Utf8.parse("ZDZXAESwebjiami1"); //""中与后台一样  密码;
    let iv = CryptoJS.enc.Utf8.parse("zdzxaesWEBJIAMI1"); //""中与后台一样
    if (typeof o === "string") {
        if (o) {
            var srcs = CryptoJS.enc.Utf8.parse(o);
            return CryptoJS.AES.encrypt(srcs, key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
        }
    }
}
/**跳转仿真页面 */
export function openVirtual(url) {
    if (process.env.NODE_ENV == 'production') {
        return process.env.VUE_APP_OSS_IP + url + '/index.html';
    } else {
        return window.location.origin + url;
    }
}
export function resImg() {
    return {
        'fz': require('../assets/image/bind/fz.png'),
        'no-fz': require('../assets/image/bind/no-fz.png'),
        'mx': require('../assets/image/bind/mx.png'),
        'no-mx': require('../assets/image/bind/no-mx.png'),
        'tp': require('../assets/image/bind/tp.png'),
        'no-tp': require('../assets/image/bind/no-tp.png'),
        'sp': require('../assets/image/bind/sp.png'),
        'no-sp': require('../assets/image/bind/no-sp.png'),
        'wd': require('../assets/image/bind/wd.png'),
        'no-wd': require('../assets/image/bind/no-wd.png'),
        'tk': require('../assets/image/bind/tk.png'),
        'no-tk': require('../assets/image/bind/no-tk.png'),
        'ppt': require('../assets/image/bind/ppt.png'),
        'no-ppt': require('../assets/image/bind/no-ppt.png'),
        'dh': require('../assets/image/bind/dh.png'),
        'no-dh': require('../assets/image/bind/no-dh.png')
    }
}
/**防抖函数 */
export function debounce(callback, timeout = 1000) {
    let timer = null;
    return function (...args) {
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            typeof callback == 'function' && callback(...args);
        }, timeout);
    }
}
/**过滤资源图标 */
export function filterResIcon(type) {
    var obj = {
        '仿真软件': require('../assets/image/bind/fz.png'),
        '动画': require('../assets/image/bind/dh.png'),
        '模型': require('../assets/image/bind/mx.png'),
        '视频': require('../assets/image/bind/sp.png'),
        'ppt': require('../assets/image/bind/ppt.png'),
        '图片': require('../assets/image/bind/tp.png'),
        '试卷': require('../assets/image/resourceLibrary/sj.png'),
        '文档': require('../assets/image/bind/wd.png'),
        '题库': require('../assets/image/bind/tk.png')
    }
    return obj[type] || '';
}
/**课程状态颜色过滤 */
export function filterStatus(status) {
    if (!status) return;
    var obj = {
        '未发布': '#EAD656',
        '审核中': '#D5698A',
        '审核不通过': '#f56c6c',
        '未开始': '#86B9FF',
        "已结束": '#8F98A9'
    }
    return obj[status] || '#67c23a';
}
/**滚轮控制图片缩放比例 */
export function scrollScale(id, imgId) {
    function handle(event) {
        event.preventDefault(); // 阻止默认的滚动行为
        const delta = event.deltaY * -0.001; // 计算缩放比例的变化量
        scale += delta; // 更新缩放比例
        scale = Math.max(0.1, Math.min(scale, 5)); // 限制缩放比例范围，避免过小或过大
        container.style.transform = `scale(${scale})`; // 应用缩放效果
    }
    const box = document.querySelector(id);
    const container = document.querySelector(imgId);
    box && box.removeEventListener('wheel', handle);
    let scale = 1; // 初始缩放比例
    box && box.addEventListener('wheel', handle);
}
/**实名认证状态 */
export function filterIdentityStatus(status) {
    if (!status) {
        return;
    }
    var obj = {
        '-1': '无认证',
        '0': '未认证',
        '1': '已认证',
        '2': '认证中',
        '3': '认证失败'
    }
    return obj[status];
}
/**仿真软件版本过滤 */
export function filterVersion(str) {
    var obj = {
        '单机': {
            label: 'pc版',
            value: 'orange'
        },
        '网页': {
            label: 'web版',
            value: 'blue'
        },
        '第三方': {
            label: 'web版',
            value: 'blue'
        },
    }
    return obj[str] || {};
}
/**任务标签过滤 */
export function filterTaskStatus(status) {
    var obj = {
        0: {
            label: '未开始',
            color: '#C2C7D9'
        },
        1: {
            label: '进行中',
            color: '#FB923C'
        },
        2: {
            label: '已完成',
            color: '#67C23A'
        },
        3:{
            label: '未考',
            color: 'rgba(245, 108, 108,0.8)'
        }
    }
    return obj[status] || {};
}
/**判断是否在时间范围内 */
export function isTimeArea(start, end) {
    start = (start ? new Date(start).getTime() : null);
    end = (end ? new Date(end).getTime() : null);
    let now = Date.now();
    if (now >= start && now < end) {
        return true;
    }
    return false;
}
/**过滤考核状态 */
export function filterExamineStatus(status) {
    let obj = {
        0: '未开始',
        1: '进行中',
        2: '已结束'
    };
    return obj[status];
}
/**防抖函数 */
export default {
    bind(el, binding) {
        let timer = null;
        const handler = (event) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                if (binding.expression && typeof binding.value === 'function') {
                    binding.value(event); // 执行绑定的方法
                }
            }, binding.arg || 300); // 默认防抖时间为 300ms
        };

        el._debounceHandler = handler;
        el.addEventListener('click', handler);
    },
    unbind(el) {
        el.removeEventListener('click', el._debounceHandler);
        delete el._debounceHandler;
    }
};
/**导出文件 */
export function download(file,fileName) {
    let a = document.createElement("a");
    const blob = new Blob([file], { type: "application/octet-stream" });
    const href = URL.createObjectURL(blob);
    document.body.appendChild(a);
    a.href = href;
    a.setAttribute("download", fileName+'.xls'||'导出文件.xls');
    a.click(); //点击触发下载
    window.URL.revokeObjectURL(href);
}
/**资源类型标签颜色筛选 */
export function resLabelColor(value){
    let obj={
        '动画':'#1D72D0',
        'ppt':'#F0546A',
        '视频':'#D43D80',
        '模型':'#2B9C7D',
        '文档':'#8D6BAC',
        '图片':'#F0A02D',
        '仿真软件':'#26C0BB',
        '题库':'#4D5A64'
    };
    return obj[value];
};
/**判断一个元素是否在另一个元素可视区域以内 */
export function observeElementInContainer(container, element, callback) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        callback(entry.isIntersecting);
      });
    }, {
      root: container, // 指定容器
      threshold: 0  // 可见比例阈值
    });
    observer.observe(element);
    return {
        observer,
        element
    }
}